import baseClasses from '@components/Themes/layout.module.scss'
import TopPagePress from '@components/TopPagePress'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { loadCardspress, searchCardspress } from '@store/actions/cardspressActions'
import { IState } from '@store/reducers/index'
import Pressmodulescss from 'dist/css/Press.module.scss'
import React, { FunctionComponent } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'

const Press: FunctionComponent = (props: any) => {
  const {
    history: navigation,
    match: { params },
  } = props
  const classes = baseClasses
  const theme = { ...baseClasses, ...Pressmodulescss }
  const allCardsPress = useSelector((state: IState) => state.cardspress).cardspress
  const cardspressData = useSelector((state: IState) => state.cardspress)
  const dispatch = useDispatch()
  const [LoadfromDatabaseCardsPressloadoptions, setLoadfromDatabaseCardsPressloadoptions] = React.useState<any>({
    page: 1,
    populate: true,
    limit: 25,
    sort: { field: null, method: 'DESC' },
    totalItems: 0,
    sortLanguage: 'en',
  })
  const performLoadfromDatabaseCardsPressload = (options) => {
    dispatch(options.searchString ? searchCardspress(options) : loadCardspress(options))
  }
  React.useEffect(() => {
    performLoadfromDatabaseCardsPressload({
      ...LoadfromDatabaseCardsPressloadoptions,
    })
  }, [LoadfromDatabaseCardsPressloadoptions])

  React.useEffect(() => {
    if (cardspressData.loadingStatus === 'loaded') {
      console.log('allCardsPress:', allCardsPress)
    }
  }, [cardspressData.loadingStatus])

  // Theme selection

  return (
    <React.Fragment>
      <div className={classes.mainPanel}>
        <div data-title="topPage" className={theme.topPage}>
          <TopPagePress />
        </div>

        <div data-title="div Container" className={theme.container}>
          <div data-title="Title " className={theme.titleRedRework}>
            <Typography variant="h1">PRENSA</Typography>

            <Typography variant="body1">
              En Real Travel, estamos para escucharte. Ya sea que tengas preguntas, necesites ayuda, o simplemente quieras compartir tus comentarios,
              nos encantaría saber de vos.
            </Typography>
          </div>

          <div data-title=" all Cards New" className={theme.allCards}>
            <div data-title="Card Posts DB" className={theme.allCards}>
              {allCardsPress.map((item, index) => {
                return (
                  <React.Fragment key={'x6mMTQWg_' + index}>
                    <div data-title="div loop Every card" className={theme.everyCard}>
                      <div data-title="div.loop Main Image" className={theme.cardsTDImg}>
                        <picture className={theme.mainImage}>
                          <img src={`/img/${item.Picture}`} alt={`/img/${item.Picture}`} />
                        </picture>
                      </div>

                      <div data-title="div title center and date " className={theme.cardsTDTitleDate}>
                        <Typography variant="h3" className={theme.cardsPressTitle}>
                          {item.Title}
                        </Typography>

                        <Typography variant="subtitle1" className={theme.cardsPressDate}>
                          {item.Date}
                        </Typography>
                      </div>

                      <div data-title="div.loop data card And Link" className={theme.cardsData}>
                        <div data-title="Description Top Left" className={theme.cardsTDDescriptionLeft}>
                          <Typography variant="h6">{item.Description}</Typography>
                        </div>

                        <div data-title="Link Bottom rigth" className={theme.cardsTDDescriptionRigth}>
                          <div data-title="Button Reservar" className={theme.tourdeskButtonReservar}>
                            <a target="_top" href={item.Link} draggable={false}>
                              <Button color="primary">Leer más</Button>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                )
              })}
            </div>
          </div>
        </div>
      </div>

      <div data-title="Footer Red" className={theme.footersRed}>
        <div data-title="div footer Left" className={theme.footerDivLeft}>
          <div data-title="div Img And Buttons Socials" className={theme.footerImgSocials}>
            <div data-title="div Img" className={theme.footerImg}>
              <picture>
                <img src="/img/RTLogo_blanco.svg" alt="/img/RTLogo_blanco.svg" />
              </picture>
            </div>

            <div data-title="div buttons socials" className={theme.footerButtonsSocials}>
              <a target="_blank" href="https://www.linkedin.com/company/realtravel/">
                <picture>
                  <img src="/img/LogoLinkedin.svg" alt="/img/LogoLinkedin.svg" />
                </picture>
              </a>

              <a href="mailto:hola@realtravel.cl?subject=Email%20de%20contacto%20por%20&body=Hola!%20Me%20contacto%20desde%20el%20website%20de%20Real%20Travel%20para%3A%20">
                <picture>
                  <img src="/img/LogoMail.svg" alt="/img/LogoMail.svg" />
                </picture>
              </a>

              <a target="_blank" href="https://www.instagram.com/realtravelap/">
                <picture>
                  <img src="/img/LogoIntagram.svg" alt="/img/LogoIntagram.svg" />
                </picture>
              </a>

              <a target="_blank" href="https://www.youtube.com/channel/UC535xN03fixDzJGFtVDAtvA/featured">
                <picture>
                  <img src="/img/logoYouTube.svg" alt="/img/logoYouTube.svg" />
                </picture>
              </a>
            </div>
          </div>

          <div data-title="div All rights reserved" className={theme.footerAllRightsReserved}>
            <Typography variant="body1">©2024 Real Travel. All rights reserved</Typography>
          </div>
        </div>

        <div data-title="div links" className={theme.footerDivCenter}>
          <NavLink to="/AboutUs">
            <Typography variant="h6">Quienes somos</Typography>
          </NavLink>

          <NavLink to="/JoinUs">
            <Typography variant="h6">Se parte</Typography>
          </NavLink>

          <NavLink to="/Press">
            <Typography variant="h6">Prensa</Typography>
          </NavLink>
        </div>

        <div data-title="Div Footer  Right" className={theme.footerDivRight}>
          <div data-title="div terms and conditions" className={theme.footerTermsAndConditions}>
            <NavLink to="/TermsAndConditions">
              <Typography variant="body1">Términos y condiciones</Typography>
            </NavLink>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Press
